import React from "react";
import {cn} from '../utils'

const CircleIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg fill="none"
         height="25"
         viewBox="0 0 24 25"
         width="24"
         className={cn(className)}
         xmlns="http://www.w3.org/2000/svg"
    >
        <path clipRule="evenodd"
              d="m12 5.0271c-4.00406 0-7.25 3.24594-7.25 7.25 0 4.0041 3.24594 7.25 7.25 7.25 4.0041 0 7.25-3.2459 7.25-7.25 0-4.00406-3.2459-7.25-7.25-7.25zm-8.75 7.25c0-4.83249 3.91751-8.75 8.75-8.75 4.8325 0 8.75 3.91751 8.75 8.75 0 4.8325-3.9175 8.75-8.75 8.75-4.83249 0-8.75-3.9175-8.75-8.75z"
              fill={color || "currentColor"} fillRule="evenodd"/>
    </svg>
);

export {CircleIcon};